const KNOWN_LABELS: Record<string, string> = {
    salada: 'Agua salada',
    dulce: 'Agua dulce',
    salt: 'Agua salada (salt)',
    'señuelo': 'Señuelo',
    cebo: 'Cebo',
};

/** Códigos internos de la App («chambel-pesca-fondo») a texto legible. */
export function codeLabel(code: string | null | undefined): string {
    const value = (code ?? '').trim();
    if (!value) return '—';
    const known = KNOWN_LABELS[value.toLowerCase()];
    if (known) return known;
    const spaced = value.replace(/[-_]+/g, ' ');
    return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
